import React, { ReactNode, useState } from 'react'
// import { FormattedMessage } from 'react-intl'

import './ResponsiveTabs.sass'

interface ResponsiveTabsProps {
  headers: ReactNode[]
  tabs: ReactNode[]
}

const ResponsiveTabs = ({ headers = [], tabs = [] }: ResponsiveTabsProps) => {
  const [selected, setSelected] = useState(0)
  return (
    <div className="responsive-tabs">
      <header className="responsive-tabs-header">
        {
          headers.map((header, i) =>
            <div
              key={i}
              className={`header-tab ${i === selected ? 'selected' : ''}`}
              onClick={() => setSelected(i)}
            >
              {header}
            </div>
          )
        }
      </header>
      <div className="responsive-tabs-content">
        {
          tabs.map((tab, i) =>
            <div
              key={i}
              className={`content-tab ${i === selected ? 'selected' : ''}`}
            >
              {tab}
            </div>
          )
        }
      </div>
    </div>
  )
}

export default ResponsiveTabs
